"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-class-component-methods */
const types_1 = require("~/store/types");
const utils_1 = require("~/utils/utils");
const three_1 = require("three");
const utils_2 = require("../utils");
const Component_model_3d_1 = __importDefault(require("./Component.model.3d"));
const consts_1 = require("../consts");
const Viewer_1 = __importDefault(require("../Viewer"));
class Fastener extends Component_model_3d_1.default {
    get fastenerState() {
        return this._fastenerState;
    }
    set fastenerState(value) {
        this._fastenerState = value;
    }
    constructor() {
        super();
        this._fastenerState = 'fasteners mode off';
        this.type = types_1.ITEM_TYPE.FASTENER;
    }
    setCatalogProps(catalogItem) {
        var _a;
        super.setCatalogProps(catalogItem);
        this.fastenerType = (0, utils_1.getItemProperty)(catalogItem, types_1.ITEM_PROPERTY_NAMES.FASTENER_TYPE);
        if (types_1.FASTENER_TYPES_OF_DOUBLE_ANCHOR_GROUP.includes((_a = this.fastenerType) !== null && _a !== void 0 ? _a : '') ||
            this.fastenerType === types_1.FASTENER_TYPES.PLATE_CONNECTOR) {
            this.fastenerSize = (0, utils_1.getDoubleAnchorGroupFastenerSizeInInches)(catalogItem);
        }
    }
    getCollisionExcludeIds() {
        const result = super.getCollisionExcludeIds();
        const { connectionManager } = Viewer_1.default.instance.getDesignProMain();
        // Fastener has exactly two connected items (and only one of them is the main).
        const mainItem = this.connectedItems.find((item) => item.isMain);
        // Add fasteners which belong to the same main object to the exclude list.
        if (mainItem) {
            connectionManager.getConnectionObjects(mainItem.uuid).forEach((connectionObject) => {
                if (connectionObject.isComponentConnection) {
                    connectionObject.getFasteners().forEach((fastener) => {
                        if (fastener.uuid !== this.uuid) {
                            result.push(fastener.uuid);
                        }
                    });
                }
            });
        }
        return result;
    }
    /**
     * @returns snapping point, which is not a master snapping point. Only for central connectors
     */
    getSecondSnappingPoint() {
        var _a;
        if (this.fastenerType &&
            ![types_1.FASTENER_TYPES.NINETY_DEGREE_CENTRAL_CONNECTOR, types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR].includes(this.fastenerType)) {
            return null;
        }
        const notMasterSnappingPoints = (_a = this.getInboundSnappingPointsRaw()) === null || _a === void 0 ? void 0 : _a.filter((point) => { var _a, _b; return utils_2.Utils.areVectorsNotEqual(point, (_b = (_a = this.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : new three_1.Vector3(Number.NaN, Number.NaN, Number.NaN)); });
        if ((notMasterSnappingPoints === null || notMasterSnappingPoints === void 0 ? void 0 : notMasterSnappingPoints.length) !== 1) {
            return null;
        }
        return notMasterSnappingPoints[0];
    }
    setVisualState(fastenerState) {
        this.fastenerState = fastenerState;
        // eslint-disable-next-line default-case
        switch (fastenerState) {
            case 'fasteners mode off':
                this.mesh.visible = true;
                this.unselect();
                this.hideSelectionBox();
                break;
            case 'default':
                this.mesh.visible = true;
                this.unselect();
                this.showSelectionBox(consts_1.consts.SELECTION_BOX_COLOR_VECTOR);
                break;
            case 'selected':
                this.mesh.visible = true;
                this.unselect();
                this.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
                break;
            case 'filled model':
                this.mesh.visible = true;
                this.select();
                this.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
                break;
            case 'empty model':
                this.unselect();
                this.mesh.visible = false;
                this.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
                break;
        }
    }
    showErrorBox() {
        super.showErrorBox();
        this.showSelectionBox(consts_1.consts.COLLISION_BOX_COLOR_VECTOR);
    }
    hideErrorBox() {
        super.hideErrorBox();
        this.hideSelectionBox();
    }
    hideSelectionBox() {
        // TODO: rewrite later
        if (!this.isCollided) {
            super.hideSelectionBox();
        }
        else {
            this.showSelectionBox(consts_1.consts.COLLISION_BOX_COLOR_VECTOR);
        }
    }
    updateMatrixWorld(force = false) {
        const objectSize = this.getSize(false);
        if (this.outerBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.outerBox, objectSize, consts_1.consts.OUTER_BOX_PADDING);
        }
        if (this.collisionBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.collisionBox, objectSize, consts_1.consts.COLLISION_BOX_PADDING);
        }
        if (this.selectionBox) {
            this.prepareBoxSizeBeforeMatrixUpdating(this.selectionBox, objectSize, consts_1.consts.SELECTION_BOX_PADDING);
        }
        three_1.Object3D.prototype.updateMatrixWorld.call(this, force);
    }
    copy(source, recursive = true) {
        super.copy(source, recursive);
        this.fastenerType = source.fastenerType;
        this.distanceToTheEdge = source.distanceToTheEdge;
        return this;
    }
    checkIfAllVisualizationDataPresent() {
        var _a, _b, _c, _d, _e;
        switch (this.fastenerType) {
            case types_1.FASTENER_TYPES.NINETY_DEGREE_CENTRAL_CONNECTOR:
            case types_1.FASTENER_TYPES.ZERO_DEGREE_CENTRAL_CONNECTOR:
                return !!(this.getAlignmentAxis() &&
                    ((_a = this.getMasterSnappingPoints()) === null || _a === void 0 ? void 0 : _a[0]) &&
                    this.distanceToTheEdge &&
                    this.getSecondSnappingPoint());
            case types_1.FASTENER_TYPES.ANCHOR_FASTENER:
            case types_1.FASTENER_TYPES.DOUBLE_ANCHOR_FASTENER:
            case types_1.FASTENER_TYPES.BOLT_CONNECTOR:
                return !!(this.getAlignmentAxis() && ((_b = this.getMasterSnappingPoints()) === null || _b === void 0 ? void 0 : _b[0]) && this.distanceToTheEdge);
            case types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREW_COMBINATION_FASTENERS:
            case types_1.FASTENER_TYPES.MILLING_CONNECTOR:
            case types_1.FASTENER_TYPES.T_MATIC_CONNECTOR:
            case types_1.FASTENER_TYPES.END_FASTENER:
                return !!(this.getAlignmentAxis() && ((_c = this.getMasterSnappingPoints()) === null || _c === void 0 ? void 0 : _c[0]));
            case types_1.FASTENER_TYPES.INNER_CONNECTOR:
            case types_1.FASTENER_TYPES.DOUBLE_END_FASTENERS:
            case types_1.FASTENER_TYPES.PLATE_CONNECTOR:
                return !!this.getAlignmentAxis();
            case types_1.FASTENER_TYPES.SOCKET_HEAD_CAP_SCREWS:
            case types_1.FASTENER_TYPES.CONNECTION_SCREWS:
            case types_1.FASTENER_TYPES.SELF_TAPPING_SCREWS:
                return !!((_d = this.getMasterSnappingPoints()) === null || _d === void 0 ? void 0 : _d[0]);
            case types_1.FASTENER_TYPES.BUTT_FASTENER:
            case types_1.FASTENER_TYPES.T_MATIC_BUTT_CONNECTOR:
            case types_1.FASTENER_TYPES.CONNECTOR_LINKS:
                return !!(this.getAlignmentAxis() && ((_e = this.getInboundSnappingPoints()) === null || _e === void 0 ? void 0 : _e.length) === 2);
            default:
                return true;
        }
    }
}
exports.default = Fastener;
